import React,{useEffect,useState} from 'react';
import Axios from '../../lib/axios/axiosInstance';
import { Container, Row, Col, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import Logo from "../../assets/images/logo.png";
import Product1 from "../../assets/images/products/img01.jpg";
import Product2 from "../../assets/images/products/img02.jpg";
import Product3 from "../../assets/images/products/img03.jpg";
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router-dom";
import * as AuthVerify from '../../lib/common';
import {BASE_URL} from '../../lib/constant';
import { Flip, Slide, toast } from 'react-toastify';

const Cart = ({confirmPage}) => {
    const navigate = useNavigate();
    const [logedIn, setLogedIn] = useState(false);
    const [userDetails, setUserDetails] = useState(false);
    const [cartDetails, setCartDetails] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    
    async function getCartDeatils (force=false) {
        if(!confirmPage){
            AuthVerify.getCartDeatils(force).then(data => {
                if(data)setCartDetails(data);
            })
        }
        else{
            setCartDetails([]);
        }
        
    }

    async function removeItem (uuid) {
        await Axios.delete(`/cart/items/${userDetails.refnum}/${uuid}`)
        .then(async (cartDetails) => {
            if (cartDetails.status == 200) {
                getCartDeatils(true);
                userDetails.cartChanged=true;
                AuthVerify.setSession(userDetails);
                toast.success('Item deleted successfully.', {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 3000,
                    transition: Slide,
                });
            }
        })
    }
    
    async function setCartItems(){
        getCartDeatils();
    }

    useEffect(() => {
        setLogedIn(AuthVerify.isUserLogedIn());
    }, []);

    useEffect(() => {
        if(logedIn){
            setUserDetails(AuthVerify.getUser())
        };
    }, [logedIn]);

    useEffect(() => {
        if(userDetails)getCartDeatils(userDetails.refnum);
    }, [userDetails]);

    const searchHandler =()=>{
        if(searchValue && searchValue!="")
            navigate(`/search?keyword=${searchValue}`)
        else
            toast.warning('Please enter product name for search.', {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                transition: Slide,
            });
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            searchHandler();
        }
    }

  return (
    <header>
    <div className="header-container">
        <Container>
        <Row>
            <Col lg={4} md={4} sm={4} xs={12}>
            {userDetails && cartDetails?.requestors && <>
                <div className="jtv-top-cart-box">
                {/* <!-- Top Cart --> */}
                <div className="mini-cart">
                <div className="basket dropdown-toggle" onMouseEnter={() => setCartItems()}>
                    {cartDetails && 
                    <>
                    <Link to="/">
                        {/* {cartDetails.items?.length ?? '0'} -  */}
                        <span className="cart_count"> {cartDetails.items && `${cartDetails.items.length} -`} Cart</span>
                    </Link>
                    </>
                    }
                </div>

                <div>
                    <div className="jtv-top-cart-content">
                    {/* <!--block-subtitle--> */}
                    <ul className="mini-products-list" id="cart-sidebar">
                        {cartDetails && cartDetails.items?.map((item,i)=>{
                            return (
                                <li className="item first" key={i}>
                            <div className="item-inner">
                                <Link className="product-image" to="/">
                                <img alt="Product Title Here" src={AuthVerify.getImageLink(item?.imageurl)} />
                                </Link>
                                <div className="product-details">
                                <div className="access">
                                    <Link className="jtv-btn-remove" to="/" onClick={()=>removeItem(item.uuid)}>
                                        Remove
                                    </Link>
                                    {/* <Link className="btn-edit" to="/">
                                    <i className="icon-pencil"></i>
                                    <span className="hidden">Edit item</span>
                                    </Link> */}
                                </div>
                                <p className="product-name">
                                    <Link to={"/product-detail?matnum="+item?.matnum}>{item.matname}</Link>
                                </p>
                                <strong>{item.qty}</strong> x{" "}
                                <span className="price">${item.uprice}</span>
                                </div>
                            </div>
                            </li>
                            )
                            
                        })}
                        

                        {/* <li className="item">
                        <div className="item-inner">
                            <Link className="product-image" to="/">
                            <img alt="Product Title Here" src={Product2} />
                            </Link>
                            <div className="product-details">
                            <div className="access">
                                <Link className="jtv-btn-remove" to="/">
                                Remove
                                </Link>
                                <Link className="btn-edit" to="/">
                                <i className="icon-pencil"></i>
                                <span className="hidden">Edit item</span>
                                </Link>
                            </div>
                            <p className="product-name">
                                <Link to="/">Product Title Here</Link>
                            </p>
                            <strong>1</strong> x{" "}
                            <span className="price">$88.89</span>
                            </div>
                        </div>
                        </li> */}
                        {/* <li className="item last">
                        <div className="item-inner">
                            <Link
                            className="product-image"
                            title="Product Title Here"
                            to="/"
                            >
                            <img alt="Product Title Here" src={Product3} />
                            </Link>
                            <div className="product-details">
                            <div className="access">
                                <Link
                                className="jtv-btn-remove"
                                title="Remove This Item"
                                to="/"
                                >
                                Remove
                                </Link>
                                <Link
                                className="btn-edit"
                                title="Edit item"
                                to="/"
                                >
                                <i className="icon-pencil"></i>
                                <span className="hidden">Edit item</span>
                                </Link>
                            </div>
                            <p className="product-name">
                                <Link to="/">Product Title Here</Link>
                            </p>
                            <strong>1</strong> x{" "}
                            <span className="price">$85.99</span>
                            </div>
                        </div>
                        </li> */}
                    </ul>

                    {cartDetails && cartDetails.carth?.grossamt && cartDetails.carth.grossamt > 0 &&
                    <div className="actions" style={{fontWeight: "500"}}>Total: ${cartDetails.carth.grossamt}</div>}
                    {/* <!--actions--> */}
                    <div className="actions">
                        <Link to="/shopping-cart" className="btn-checkout" style={{textAlign:"center"}}>
                        <span>Checkout</span>
                        </Link>
                        <Link to="/shopping-cart" className="view-cart">
                        <span>View Cart</span>
                        </Link>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <div className="jtv-top-cart-box" style={{display:"none"}}>
                {/* <!-- Top Cart --> */}
                <div className="mini-cart">
                <div className="basket dropdown-toggle">
                    <Link to="/">
                    <span className="cart_count">0 - Draft</span>
                    </Link>
                </div>
                <div>
                    <div className="jtv-top-cart-content jtv-top-cart-content-2">
                    {/* <!--block-subtitle--> */}
                    <ul className="mini-products-list" id="cart-sidebar">
                        <li className="item first">
                        <div className="item-inner">
                            <Link
                            className="product-image"
                            title="Product Title Here"
                            to="/"
                            >
                            <img alt="Product Title Here" src={AuthVerify.getImageLink(Product1)} />
                            </Link>
                            <div className="product-details">
                            <div className="access">
                                <Link
                                className="jtv-btn-remove"
                                title="Remove This Item"
                                to="/"
                                >
                                Remove
                                </Link>
                                <Link
                                className="btn-edit"
                                title="Edit item"
                                to="/"
                                >
                                <i className="icon-pencil"></i>
                                <span className="hidden">Edit item</span>
                                </Link>
                            </div>
                            <p className="product-name">
                                <Link to="/">Product Title Here</Link>
                            </p>
                            <strong>1</strong> x{" "}
                            <span className="price">$79.99</span>
                            </div>
                        </div>
                        </li>
                        <li className="item">
                        <div className="item-inner">
                            <Link
                            className="product-image"
                            title="Product Title Here"
                            to="/"
                            >
                            <img alt="Product Title Here" src={AuthVerify.getImageLink(Product2)} />
                            </Link>
                            <div className="product-details">
                            <div className="access">
                                <Link
                                className="jtv-btn-remove"
                                title="Remove This Item"
                                to="/"
                                >
                                Remove
                                </Link>
                                <Link
                                className="btn-edit"
                                title="Edit item"
                                to="/"
                                >
                                <i className="icon-pencil"></i>
                                <span className="hidden">Edit item</span>
                                </Link>
                            </div>
                            <p className="product-name">
                                <Link to="/">Product Title Here</Link>
                            </p>
                            <strong>1</strong> x{" "}
                            <span className="price">$88.89</span>
                            </div>
                        </div>
                        </li>
                        <li className="item last">
                        <div className="item-inner">
                            <Link
                            className="product-image"
                            title="Product Title Here"
                            to="/"
                            >
                            <img alt="Product Title Here" src={AuthVerify.getImageLink(Product3)} />
                            </Link>
                            <div className="product-details">
                            <div className="access">
                                <Link
                                className="jtv-btn-remove"
                                title="Remove This Item"
                                to="/"
                                >
                                Remove
                                </Link>
                                <Link
                                className="btn-edit"
                                title="Edit item"
                                to="/"
                                >
                                <i className="icon-pencil"></i>
                                <span className="hidden">Edit item</span>
                                </Link>
                            </div>
                            <p className="product-name">
                                <Link to="/">Product Title Here</Link>
                            </p>
                            <strong>1</strong> x{" "}
                            <span className="price">$85.99</span>
                            </div>
                        </div>
                        </li>
                    </ul>

                    {/* <!--actions--> */}
                    <div className="actions">
                        <button
                        className="btn-checkout"
                        title="Checkout"
                        type="button"
                        >
                        <span>Checkout</span>
                        </button>
                        <Link to="/shopping-cart" className="view-cart">
                        <span>View Cart</span>
                        </Link>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            </>}
            
            
            </Col>
            <Col lg={4} md={4} sm={4} xs={12} className="jtv-logo-box">
            {/* <!-- Header Logo --> */}
            <div className="logo">
                <Link title="eCommerce" to="/">
                <img alt="eCommerce" src={Logo} style={{maxHeight:"75px"}}/>
                </Link>
            </div>
            {/* <!-- End Header Logo --> */}
            </Col>
            <Col lg={4} md={4} sm={4} xs={12} className="hidden-xs"> 
            <div className="search-box">
                {/* <form id="search_mini_form" name="Categories"> */}
                <input
                    type="text"
                    placeholder="Search keywords for products..."
                    maxLength="70"
                    // name="search"
                    className='pressEnterAction'
                    value={searchValue}
                    onChange={e=>setSearchValue(e.target.value)}
                    onKeyDown={handleKeyDown}
                    id="search"
                />
                <button type="button"  id='pressEnterActionBtn' className="search-btn-bg" onClick={searchHandler}>
                    <span className="glyphicon glyphicon-search"></span>&nbsp;
                </button>
                {/* </form> */}
            </div>
            </Col>
        </Row>
        </Container>
    </div>
    </header>
  );
};

export default Cart;
